import SvgIcon from '@elementor/ui/SvgIcon';

export const GradientLogo = () => (
	<SvgIcon width="24" height="24" fill="none" viewBox="0 0 24 24">
		<g clipPath="url(#a)">
			<path
				fill="url(#b)"
				fillRule="evenodd"
				d="M2.022 18.667A12 12 0 1 1 21.977 5.333 12 12 0 0 1 2.022 18.667M9 7H7v10h2zm8 0h-6v2h6zm0 3.999h-6v2h6zM17 15h-6v2h6z"
				clipRule="evenodd"
			/>
		</g>

		<defs>
			<linearGradient
				id="b"
				x1="8.556"
				x2="41.873"
				y1="24"
				y2="12.805"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#2847f3" />
				<stop offset=".846" stopColor="#17298d" />
			</linearGradient>

			<clipPath id="a">
				<path fill="#fff" d="M0 0h24v24H0z" />
			</clipPath>
		</defs>
	</SvgIcon>
);
